// extracted by mini-css-extract-plugin
export default {"wrapper":"Textarea_wrapper__WCmkL","input":"Textarea_input__wkS6K"};